import * as React from "react";

function StatUserIcon() {
	return (
		<svg
			width={64}
			height={64}
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width={64} height={64} rx={24} fill="#83BDE4" />
			<path
				d="M38.5 24.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zM20.5 42.833c0-1.146.803-2.97 2.72-4.544C25.1 36.746 27.998 35.5 32 35.5c4.003 0 6.9 1.246 8.78 2.789 1.917 1.574 2.72 3.398 2.72 4.544V44.5A1.5 1.5 0 0142 46H22a1.5 1.5 0 01-1.5-1.5v-1.667z"
				fill="#fff"
				stroke="#4D3951"
				strokeWidth={2}
			/>
		</svg>
	);
}

export default StatUserIcon;
